import { FormControl, FormGroup } from '@angular/forms';
import { DescricaoAtributo } from '../functions/DescricaoAtributo';
import { AssuntoDTO } from './AssuntoDTO';
import { Classificacao } from './Classificacao';
import { UnidadeDTO } from './UnidadeDTO';
import { Municipio } from './Municipio';
import { ServicoNotarialInfoDTO } from './ServicoNotarialInfoDTO';
import { MunicipioDTO } from './MunicipioDTO';
import { Denuncia_Tortura_OrigemNotificacao } from './Denuncia_Tortura_OrigemNotificacao';
import { Denuncia_Tortura_OrgaoVinculadoAgressores } from './Denuncia_Tortura_OrgaoVinculadoAgressores';
import {DenunciaInfanciaJuventude} from "./Denuncia_Infancia_Juventude";

@DescricaoAtributo({
  nome: 'Nome do Usuário',
  email: 'Email do Usuário',
  descricaoDenuncia: 'Descrição da Denúncia',
  listaClassificacao: 'Assunto(s)',
  assunto: 'Assunto',
})
export class DenunciaVO {
  id: number;
  username: FormControl | string = '';
  dataHoraAbertura: Date;
  nome: FormControl | string;
  email: FormControl | string;
  descricaoDenuncia: FormControl | string;
  anonimo: FormControl | boolean;

  listaClassificacao: FormControl | Classificacao[];
  listaClassificacaoCompleta: Classificacao[];

  listaUnidade: UnidadeDTO[];
  unidadeAux1: FormControl;
  unidadeAux2: FormControl;

  files: any[] = [];

  assunto: FormControl | AssuntoDTO;
  assuntos: AssuntoDTO[];

  listaMunicipio: MunicipioDTO[];
  listaComarcas: MunicipioDTO[];
  listaServentia: ServicoNotarialInfoDTO[];
  codigoMunicipio: FormControl | number;
  codigoCNS: FormControl | number;
  nomeMunicipio: FormControl | string;
  nomeServentia: FormControl | string;
  localidade: FormControl | string;
  codigoComarca: FormControl | number;

  demandaRecebida: FormControl | string = '';

  listaOrigemNotificacao: FormControl | Denuncia_Tortura_OrigemNotificacao[];
  listaOrigemNotificacaoPublicoExterno: Denuncia_Tortura_OrigemNotificacao[];
  listaOrigemNotificacaoPublicoInterno: Denuncia_Tortura_OrigemNotificacao[];
  publicoOrigemNotificacao: FormControl | string;
  tipoPessoaNotificante: FormControl | string;
  nomeNotificante: FormControl | string;
  nomeSocialNotificante: FormControl | string;
  cpfCnpjNotificante: FormControl | string;
  rgNotificante: FormControl | string;
  orgaoExpedidorNotificante: FormControl | string;
  ufOrgaoExpedidorNotificante: FormControl | string;
  emailNotificante: FormControl | string;
  vitimas: FormControl | string;
  agressores: FormControl | string;
  funcaoCargoAgressores: FormControl | string;
  listaOrgaoVinculadoAgressores: FormControl | Denuncia_Tortura_OrgaoVinculadoAgressores[];
  listaOrgaoVinculadoAgressoresCompleta: Denuncia_Tortura_OrgaoVinculadoAgressores[];
  outrosOrgaos: FormControl | string;
  localFato: FormControl | string;
  dataHoraFato: Date;
  testemunhas: FormControl | string;
  nomeUnidadePrisionalSocioeducativa: FormControl | string;
  numeroDenunciaAnonima: string;
  // Infancia e Juventude
  infancia: FormGroup  | DenunciaInfanciaJuventude;

  denunciaAssedio: FormGroup | any;


  listaArea: any[];
  listaConduta: any[];
  listaFuncao: any[];
  listaEscolaridade: any[];
  listaTipoDeficiencia: any[];
  listaCorRaca: any[];
  listaSetor: any[];

}
